import { StoreCategory } from '../models';

const FEATURED_CATEGORY_PATTERNS = [
  /conjunto.*short/,
  /^vestido/,
  /^short/,
  /^blusa/,
  /t-?shirt/,
  /cal[cç]a/,
  /acess/,
  /camisaria/,
];

const normalize = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

function matchFeatured(categories: StoreCategory[]): StoreCategory[] {
  const picked: StoreCategory[] = [];
  FEATURED_CATEGORY_PATTERNS.forEach((pattern) => {
    const match = categories.find((c) => pattern.test(normalize(c.name)) && !picked.includes(c));
    if (match) picked.push(match);
  });
  return picked;
}

export function pickFeaturedCategories(categories: StoreCategory[]): StoreCategory[] {
  const picked = matchFeatured(categories);
  return picked.length > 0 ? picked : categories.slice(0, FEATURED_CATEGORY_PATTERNS.length);
}

export function sortFeaturedFirst(categories: StoreCategory[]): StoreCategory[] {
  const featured = matchFeatured(categories);
  return [...featured, ...categories.filter((c) => !featured.includes(c))];
}
